import { Component, Input, OnInit } from '@angular/core';
import { TransferRequestService } from 'src/app/shared/services/transfer-request.service';
import { ITransferRequest } from 'src/app/_models/transfer-sections/ITransferRequest';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input() step: number;
  @Input() progress: number;
  @Input() schemeId?: number;
  @Input() userType: number = 1;
  transferRequest: ITransferRequest;
  skeleton: boolean = true;
  id = null;
  constructor(private transferRequestService: TransferRequestService,) { }

  ngOnInit(): void {
    this.getTransferRequest();
  }
  getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        console.log(response)
        this.id = response.id
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }
}
